import { useRef } from "react";

export type GroupColumnWidths = ReadonlyMap<string, number>;

export type TopBuildingsListGroupHeaderProps = {
  name: string;
  onResizeStart: () => GroupColumnWidths;
  onResize: (startWidths: GroupColumnWidths, delta: number) => void;
};

export const TopBuildingsListGroupHeader = ({ name, onResizeStart, onResize }: TopBuildingsListGroupHeaderProps) => {
  const resizeStart = useRef<{ x: number; widths: GroupColumnWidths } | null>(null);

  return (
    <>
      <span className="TopBuildingsList__GroupHeader__Name">{name}</span>
      <div
        aria-hidden
        className="rdg-resize-handle"
        onClick={(event) => event.stopPropagation()}
        onPointerDown={(event) => {
          if (event.pointerType === "mouse" && event.buttons !== 1) return;
          event.preventDefault();
          event.currentTarget.setPointerCapture(event.pointerId);
          resizeStart.current = { x: event.clientX, widths: onResizeStart() };
        }}
        onPointerMove={(event) => {
          const start = resizeStart.current;
          if (start) onResize(start.widths, event.clientX - start.x);
        }}
        onLostPointerCapture={() => {
          resizeStart.current = null;
        }}
      />
    </>
  );
};
